// import React, { useState, useEffect } from 'react';
// import MobileApplicationForm from './MobileApplicationForm';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Navbar from '../NewHero/Navigatinbar';

// const ApplicationForm = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 640);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   if (isMobile) {
//     return <MobileApplicationForm />;
//   }

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     position: '',
//     experience: '',
//     availability: '',
//     qualifications: '',
//     motivation: '',
//     termsAccepted: false,
//   });

//   const [errors, setErrors] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
//     if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email';
//     }
//     if (!formData.phone.trim()) {
//       newErrors.phone = 'Phone number is required';
//     } else if (!/^[0-9+\-\s]+$/.test(formData.phone)) {
//       newErrors.phone = 'Please enter a valid phone number';
//     }
//     if (!formData.position) newErrors.position = 'Please select a position';
//     if (!formData.experience) newErrors.experience = 'Please select experience';
//     if (!formData.availability) newErrors.availability = 'Please select availability';
//     if (!formData.qualifications.trim()) newErrors.qualifications = 'Qualifications are required';
//     if (!formData.motivation.trim()) newErrors.motivation = 'Motivation statement is required';
//     if (!formData.termsAccepted) newErrors.termsAccepted = 'You must accept the terms';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//     // Clear error when user types
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {
//       const response = await fetch('https://righttime-backend.onrender.com/send', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }

//       toast.success('Application submitted successfully!', {
//         position: "top-center",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });

//       setFormData({
//         firstName: '',
//         lastName: '',
//         email: '',
//         phone: '',
//         position: '',
//         experience: '',
//         availability: '',
//         qualifications: '',
//         motivation: '',
//         termsAccepted: false,
//       });
//     } catch (error) {
//       toast.error('Submission failed. Please try again.', {
//         position: "top-center",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//       <Navbar />
//       <ToastContainer />
//       <div className="max-w-4xl mx-auto">
//         {/* Header Section */}
//         <div className="text-center mb-12">
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 font-['Readex_Pro']">
//             Apply Today
//           </h1>
//           <p className="mt-4 text-lg sm:text-xl md:text-2xl text-gray-500 font-['Readex_Pro'] leading-relaxed">
//             Take the first step towards your rewarding career in healthcare
//           </p>
//         </div>

//         {/* Form Container */}
//         <form
//           onSubmit={handleSubmit}
//           className="bg-white rounded-3xl shadow-sm border border-neutral-200 p-6 sm:p-8 md:p-12 transition-all hover:shadow-md"
//         >
//           <div className="space-y-8">
//             {/* Name Fields */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div className="space-y-2">
//                 <label
//                   htmlFor="firstName"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   First Name *
//                 </label>
//                 <input
//                   type="text"
//                   id="firstName"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   placeholder="Enter your first name"
//                   className={`w-full p-3 border ${errors.firstName ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                 />
//                 {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
//               </div>
//               <div className="space-y-2">
//                 <label
//                   htmlFor="lastName"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Last Name *
//                 </label>
//                 <input
//                   type="text"
//                   id="lastName"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   placeholder="Enter your last name"
//                   className={`w-full p-3 border ${errors.lastName ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                 />
//                 {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
//               </div>
//             </div>

//             {/* Contact Fields */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div className="space-y-2">
//                 <label
//                   htmlFor="email"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Email Address *
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   placeholder="your.email@example.com"
//                   className={`w-full p-3 border ${errors.email ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                 />
//                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//               </div>
//               <div className="space-y-2">
//                 <label
//                   htmlFor="phone"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Phone Number *
//                 </label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   placeholder="07123 456789"
//                   className={`w-full p-3 border ${errors.phone ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                 />
//                 {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//               </div>
//             </div>

//             {/* Dropdown Fields */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               <div className="space-y-2">
//                 <label
//                   htmlFor="position"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Position *
//                 </label>
//                 <div className="relative">
//                   <select
//                     id="position"
//                     name="position"
//                     value={formData.position}
//                     onChange={handleInputChange}
//                     className={`w-full p-3 border ${errors.position ? 'border-red-500' : 'border-neutral-200'} rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                   >
//                     <option value="" disabled>Select position</option>
//                     <option value="nurse">Nurse</option>
//                     <option value="doctor">Doctor</option>
//                     <option value="technician">Technician</option>
//                     <option value="administrator">Administrator</option>
//                     <option value="other">Other</option>
//                   </select>
//                   <svg
//                     className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-700"
//                     fill="none"
//                     viewBox="0 0 20 20"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       clipRule="evenodd"
//                       d="M0.292308 4.86572C-0.097436 5.2706 -0.097436 5.92623 0.292308 6.33008L8.55587 14.8926C9.33636 15.7023 10.6025 15.7023 11.383 14.8926L19.7075 6.26807C20.0933 5.86732 20.0983 5.21989 19.7175 4.81397C19.3288 4.39977 18.6882 4.39475 18.2935 4.80274L10.6765 12.6963C10.2857 13.1012 9.65314 13.1012 9.2624 12.6963L1.70538 4.86572C1.31563 4.46083 0.683051 4.46083 0.292308 4.86572Z"
//                       fill="currentColor"
//                     />
//                   </svg>
//                 </div>
//                 {errors.position && <p className="text-red-500 text-sm mt-1">{errors.position}</p>}
//               </div>
//               <div className="space-y-2">
//                 <label
//                   htmlFor="experience"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Experience *
//                 </label>
//                 <div className="relative">
//                   <select
//                     id="experience"
//                     name="experience"
//                     value={formData.experience}
//                     onChange={handleInputChange}
//                     className={`w-full p-3 border ${errors.experience ? 'border-red-500' : 'border-neutral-200'} rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                   >
//                     <option value="" disabled>Select experience</option>
//                     <option value="0-2">0-2 years</option>
//                     <option value="2-5">2-5 years</option>
//                     <option value="5-10">5-10 years</option>
//                     <option value="10+">10+ years</option>
//                   </select>
//                   <svg
//                     className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-700"
//                     fill="none"
//                     viewBox="0 0 20 20"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       clipRule="evenodd"
//                       d="M0.292308 4.86572C-0.097436 5.2706 -0.097436 5.92623 0.292308 6.33008L8.55587 14.8926C9.33636 15.7023 10.6025 15.7023 11.383 14.8926L19.7075 6.26807C20.0933 5.86732 20.0983 5.21989 19.7175 4.81397C19.3288 4.39977 18.6882 4.39475 18.2935 4.80274L10.6765 12.6963C10.2857 13.1012 9.65314 13.1012 9.2624 12.6963L1.70538 4.86572C1.31563 4.46083 0.683051 4.46083 0.292308 4.86572Z"
//                       fill="currentColor"
//                     />
//                   </svg>
//                 </div>
//                 {errors.experience && <p className="text-red-500 text-sm mt-1">{errors.experience}</p>}
//               </div>
//               <div className="space-y-2">
//                 <label
//                   htmlFor="availability"
//                   className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//                 >
//                   Availability *
//                 </label>
//                 <div className="relative">
//                   <select
//                     id="availability"
//                     name="availability"
//                     value={formData.availability}
//                     onChange={handleInputChange}
//                     className={`w-full p-3 border ${errors.availability ? 'border-red-500' : 'border-neutral-200'} rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//                   >
//                     <option value="" disabled>Select availability</option>
//                     <option value="full-time">Full-time</option>
//                     <option value="part-time">Part-time</option>
//                     <option value="contract">Contract</option>
//                     <option value="flexible">Flexible</option>
//                   </select>
//                   <svg
//                     className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-700"
//                     fill="none"
//                     viewBox="0 0 20 20"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       clipRule="evenodd"
//                       d="M0.292308 4.86572C-0.097436 5.2706 -0.097436 5.92623 0.292308 6.33008L8.55587 14.8926C9.33636 15.7023 10.6025 15.7023 11.383 14.8926L19.7075 6.26807C20.0933 5.86732 20.0983 5.21989 19.7175 4.81397C19.3288 4.39977 18.6882 4.39475 18.2935 4.80274L10.6765 12.6963C10.2857 13.1012 9.65314 13.1012 9.2624 12.6963L1.70538 4.86572C1.31563 4.46083 0.683051 4.46083 0.292308 4.86572Z"
//                       fill="currentColor"
//                     />
//                   </svg>
//                 </div>
//                 {errors.availability && <p className="text-red-500 text-sm mt-1">{errors.availability}</p>}
//               </div>
//             </div>

//             {/* Qualifications */}
//             <div className="space-y-2">
//               <label
//                 htmlFor="qualifications"
//                 className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//               >
//                 Qualifications & Certifications *
//               </label>
//               <textarea
//                 id="qualifications"
//                 name="qualifications"
//                 value={formData.qualifications}
//                 onChange={handleInputChange}
//                 placeholder="Please list your relevant qualifications, certifications, and training..."
//                 className={`w-full p-3 border ${errors.qualifications ? 'border-red-500' : 'border-neutral-200'} rounded-md h-32 focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//               />
//               {errors.qualifications && <p className="text-red-500 text-sm mt-1">{errors.qualifications}</p>}
//             </div>

//             {/* Motivation */}
//             <div className="space-y-2">
//               <label
//                 htmlFor="motivation"
//                 className="block text-lg font-medium text-gray-900 font-['Readex_Pro']"
//               >
//                 Why do you want to join RightTime Medicals *
//               </label>
//               <textarea
//                 id="motivation"
//                 name="motivation"
//                 value={formData.motivation}
//                 onChange={handleInputChange}
//                 placeholder="Tell us about your motivation to work in healthcare and why you'd like to join our team..."
//                 className={`w-full p-3 border ${errors.motivation ? 'border-red-500' : 'border-neutral-200'} rounded-md h-40 focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
//               />
//               {errors.motivation && <p className="text-red-500 text-sm mt-1">{errors.motivation}</p>}
//             </div>

//             {/* Terms Checkbox */}
//             <div className="flex items-start gap-3">
//               <input
//                 type="checkbox"
//                 id="termsAccepted"
//                 name="termsAccepted"
//                 checked={formData.termsAccepted}
//                 onChange={handleInputChange}
//                 className={`mt-1 w-5 h-5 border ${errors.termsAccepted ? 'border-red-500' : 'border-neutral-300'} rounded focus:ring-green-600`}
//               />
//               <label
//                 htmlFor="termsAccepted"
//                 className="text-lg font-medium text-neutral-700 font-['Readex_Pro']"
//               >
//                 I agree to the <a href="/terms" className="text-green-600 hover:underline">terms and conditions</a> and <a href="/privacy" className="text-green-600 hover:underline">privacy policy</a> *
//               </label>
//             </div>
//             {errors.termsAccepted && <p className="text-red-500 text-sm mt-1 ml-8">{errors.termsAccepted}</p>}

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={isSubmitting}
//               className={`w-full sm:w-auto px-8 py-4 bg-green-600 text-white text-xl font-medium rounded-2xl hover:bg-green-700 transition-colors flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
//             >
//               {isSubmitting ? (
//                 <>
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Processing...
//                 </>
//               ) : (
//                 <>
//                   Submit Application
//                   <svg
//                     className="w-4 h-4"
//                     fill="none"
//                     viewBox="0 0 16 15"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M1.07691 8.07691H13.5298L7.59326 14.0163C7.48581 14.1244 7.4255 14.2706 7.4255 14.4231C7.4255 14.5755 7.48581 14.7217 7.59326 14.8298C7.70136 14.9372 7.84758 14.9976 7.99999 14.9976C8.15241 14.9976 8.29863 14.9372 8.40672 14.8298L15.3298 7.90672C15.3571 7.87968 15.3813 7.84969 15.4019 7.81729C15.4111 7.80818 15.4198 7.79854 15.4279 7.78845C15.4279 7.76825 15.4481 7.75095 15.4567 7.73075L15.474 7.67306C15.4757 7.65676 15.4757 7.64033 15.474 7.62402C15.4888 7.54975 15.4888 7.4733 15.474 7.39902C15.4757 7.38272 15.4757 7.36629 15.474 7.34999L15.4567 7.29229C15.4567 7.2721 15.4365 7.25479 15.4279 7.2346C15.4203 7.21956 15.4116 7.2051 15.4019 7.19133C15.3813 7.15893 15.3571 7.12894 15.3298 7.10191L8.40672 0.17883C8.355 0.118437 8.29136 0.0693874 8.21978 0.0347586C8.14821 0.0001297 8.07025 -0.019331 7.99079 -0.0223999C7.91134 -0.0254688 7.83211 -0.0120802 7.75808 0.0169239C7.68404 0.045929 7.6168 0.0899239 7.56058 0.146148C7.50436 0.202372 7.46036 0.26961 7.43136 0.343644C7.40235 0.417678 7.38896 0.496908 7.39203 0.576362C7.3951 0.655815 7.41456 0.733776 7.44919 0.805351C7.48382 0.876927 7.53287 0.940573 7.59326 0.992292L13.5298 6.92306H1.07691C0.923905 6.92306 0.777163 6.98384 0.668968 7.09204C0.560775 7.20023 0.499992 7.34698 0.499992 7.49999C0.499992 7.653 0.560775 7.79974 0.668968 7.90793C0.777163 8.01613 0.923905 8.07691 1.07691 8.07691Z"
//                       fill="white"
//                     />
//                   </svg>
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ApplicationForm;




import React, { useState, useEffect } from 'react';
import MobileApplicationForm from './MobileApplicationForm';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowRight, Loader2 } from 'lucide-react'; // Using Lucide icons from your installed packages
import Navbar from '../NewHero/Navigatinbar';

const ApplicationForm = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    // Set initial value
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    availability: '',
    qualifications: '',
    motivation: '',
    termsAccepted: false,
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^[0-9+\-\s]+$/.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }
    if (!formData.position) newErrors.position = 'Please select a position';
    if (!formData.experience) newErrors.experience = 'Please select experience';
    if (!formData.availability) newErrors.availability = 'Please select availability';
    if (!formData.qualifications.trim()) newErrors.qualifications = 'Qualifications are required';
    if (!formData.motivation.trim()) newErrors.motivation = 'Motivation statement is required';
    if (!formData.termsAccepted) newErrors.termsAccepted = 'You must accept the terms';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    // Clear error when user types
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const response = await fetch('https://righttime-backend.onrender.com/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      toast.success('Application submitted successfully!', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        experience: '',
        availability: '',
        qualifications: '',
        motivation: '',
        termsAccepted: false,
      });
    } catch (error) {
      toast.error('Submission failed. Please try again.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isMobile) {
    return <MobileApplicationForm />;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Navbar />
      <ToastContainer />
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            Apply Today
          </h1>
          <p className="mt-4 text-lg sm:text-xl md:text-2xl text-gray-500 leading-relaxed">
            Take the first step towards your rewarding career in healthcare
          </p>
        </div>

        {/* Form Container */}
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-3xl shadow-sm border border-neutral-200 p-6 sm:p-8 md:p-12 transition-all hover:shadow-md"
        >
          <div className="space-y-8">
            {/* Name Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormField
                label="First Name *"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Enter your first name"
                error={errors.firstName}
                type="text"
              />
              <FormField
                label="Last Name *"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter your last name"
                error={errors.lastName}
                type="text"
              />
            </div>

            {/* Contact Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormField
                label="Email Address *"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
                error={errors.email}
                type="email"
              />
              <FormField
                label="Phone Number *"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="07123 456789"
                error={errors.phone}
                type="tel"
              />
            </div>

            {/* Dropdown Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              <SelectField
                label="Position *"
                id="position"
                name="position"
                value={formData.position}
                onChange={handleInputChange}
                error={errors.position}
                options={[
                  { value: '', label: 'Select position', disabled: true },
                  { value: 'nurse', label: 'Nurse' },
                  { value: 'doctor', label: 'Doctor' },
                  { value: 'technician', label: 'Technician' },
                  { value: 'administrator', label: 'Administrator' },
                  { value: 'other', label: 'Other' }
                ]}
              />
              <SelectField
                label="Experience *"
                id="experience"
                name="experience"
                value={formData.experience}
                onChange={handleInputChange}
                error={errors.experience}
                options={[
                  { value: '', label: 'Select experience', disabled: true },
                  { value: '0-2', label: '0-2 years' },
                  { value: '2-5', label: '2-5 years' },
                  { value: '5-10', label: '5-10 years' },
                  { value: '10+', label: '10+ years' }
                ]}
              />
              <SelectField
                label="Availability *"
                id="availability"
                name="availability"
                value={formData.availability}
                onChange={handleInputChange}
                error={errors.availability}
                options={[
                  { value: '', label: 'Select availability', disabled: true },
                  { value: 'full-time', label: 'Full-time' },
                  { value: 'part-time', label: 'Part-time' },
                  { value: 'contract', label: 'Contract' },
                  { value: 'flexible', label: 'Flexible' }
                ]}
              />
            </div>

            {/* Qualifications */}
            <TextareaField
              label="Qualifications & Certifications *"
              id="qualifications"
              name="qualifications"
              value={formData.qualifications}
              onChange={handleInputChange}
              placeholder="Please list your relevant qualifications, certifications, and training..."
              error={errors.qualifications}
              rows={5}
            />

            {/* Motivation */}
            <TextareaField
              label="Why do you want to join RightTime Medicals *"
              id="motivation"
              name="motivation"
              value={formData.motivation}
              onChange={handleInputChange}
              placeholder="Tell us about your motivation to work in healthcare and why you'd like to join our team..."
              error={errors.motivation}
              rows={6}
            />

            {/* Terms Checkbox */}
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="termsAccepted"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleInputChange}
                className={`mt-1 w-5 h-5 border ${errors.termsAccepted ? 'border-red-500' : 'border-neutral-300'} rounded focus:ring-green-600`}
              />
              <label
                htmlFor="termsAccepted"
                className="text-lg font-medium text-neutral-700"
              >
                I agree to the <a href="/terms" className="text-green-600 hover:underline">terms and conditions</a> and <a href="/privacy" className="text-green-600 hover:underline">privacy policy</a> *
              </label>
            </div>
            {errors.termsAccepted && <p className="text-red-500 text-sm mt-1 ml-8">{errors.termsAccepted}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full sm:w-auto px-8 py-4 bg-green-600 text-white text-xl font-medium rounded-2xl hover:bg-green-700 transition-colors flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="animate-spin h-5 w-5" />
                  Processing...
                </>
              ) : (
                <>
                  Submit Application
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Reusable Form Field Component
const FormField = ({ label, id, name, value, onChange, placeholder, error, type = 'text' }) => (
  <div className="space-y-2">
    <label htmlFor={id} className="block text-lg font-medium text-gray-900">
      {label}
    </label>
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full p-3 border ${error ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
    />
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

// Reusable Select Field Component
const SelectField = ({ label, id, name, value, onChange, error, options }) => (
  <div className="space-y-2">
    <label htmlFor={id} className="block text-lg font-medium text-gray-900">
      {label}
    </label>
    <div className="relative">
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full p-3 border ${error ? 'border-red-500' : 'border-neutral-200'} rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      <svg
        className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-700 pointer-events-none"
        fill="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.292308 4.86572C-0.097436 5.2706 -0.097436 5.92623 0.292308 6.33008L8.55587 14.8926C9.33636 15.7023 10.6025 15.7023 11.383 14.8926L19.7075 6.26807C20.0933 5.86732 20.0983 5.21989 19.7175 4.81397C19.3288 4.39977 18.6882 4.39475 18.2935 4.80274L10.6765 12.6963C10.2857 13.1012 9.65314 13.1012 9.2624 12.6963L1.70538 4.86572C1.31563 4.46083 0.683051 4.46083 0.292308 4.86572Z"
          fill="currentColor"
        />
      </svg>
    </div>
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

// Reusable Textarea Field Component
const TextareaField = ({ label, id, name, value, onChange, placeholder, error, rows = 4 }) => (
  <div className="space-y-2">
    <label htmlFor={id} className="block text-lg font-medium text-gray-900">
      {label}
    </label>
    <textarea
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={`w-full p-3 border ${error ? 'border-red-500' : 'border-neutral-200'} rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 text-gray-700`}
    />
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

export default ApplicationForm;